import {
  ConversationChannelIcon,
  ConversationChannelIconKind,
} from '../../conversations/conversationChannelIcons';

export type ConnectorTab = 'telegram' | 'whatsapp' | 'whatsapp-cloud' | 'instagram' | 'messenger' | 'tiktok' | 'webchat' | 'calls' | 'sms';

const CONNECTOR_TAB_KIND: Record<ConnectorTab, ConversationChannelIconKind> = {
  telegram: 'telegram',
  whatsapp: 'whatsApp',
  'whatsapp-cloud': 'whatsApp',
  instagram: 'instagram',
  messenger: 'messenger',
  tiktok: 'tiktok',
  webchat: 'webchat',
  calls: 'phone',
  sms: 'phone',
};

export const getConnectorTabChannelIcon = (tab: ConnectorTab, label: string): ConversationChannelIcon => ({
  key: tab,
  kind: CONNECTOR_TAB_KIND[tab],
  label,
});
